"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResult = void 0;
class NoResult {
    constructor() { }
}
exports.NoResult = NoResult;
NoResult.instance = new NoResult();
//# sourceMappingURL=no-result.js.map